import { GET_TERRITORIES, SET_TERRITORIES } from '../actions/actionTypes';

const initialState = {
  list: [],
  isLoading: false,
  isLoaded: false
};

const territoriesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TERRITORIES:
      return { ...state, isLoading: true };
    case SET_TERRITORIES:
      return {
        ...state,
        list: action.territories,
        isLoaded: true,
        isLoading: false
      };
    default:
      return state;
  }
};

export default territoriesReducer;
